import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18f56e9e&scoped=true"
import script from "./myQuestions.js?vue&type=script&lang=js&external"
export * from "./myQuestions.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=18f56e9e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f56e9e",
  null
  
)

export default component.exports